var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrCrossSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0018 4.99999C14.8455 4.84376 14.6336 4.756 14.4126 4.756C14.1917 4.756 13.9797 4.84376 13.8235 4.99999L10.0018 8.82165L6.18013 4.99999C6.02386 4.84376 5.81194 4.756 5.59097 4.756C5.37 4.756 5.15807 4.84376 5.0018 4.99999C4.84558 5.15626 4.75781 5.36818 4.75781 5.58915C4.75781 5.81012 4.84558 6.02205 5.0018 6.17832L8.82347 9.99999L5.0018 13.8217C4.84558 13.9779 4.75781 14.1898 4.75781 14.4108C4.75781 14.6318 4.84558 14.8437 5.0018 15C5.15807 15.1562 5.37 15.244 5.59097 15.244C5.81194 15.244 6.02386 15.1562 6.18013 15L10.0018 11.1783L13.8235 15C13.9797 15.1562 14.1917 15.244 14.4126 15.244C14.6336 15.244 14.8455 15.1562 15.0018 15C15.158 14.8437 15.2458 14.6318 15.2458 14.4108C15.2458 14.1898 15.158 13.9779 15.0018 13.8217L11.1801 9.99999L15.0018 6.17832C15.158 6.02205 15.2458 5.81012 15.2458 5.58915C15.2458 5.36818 15.158 5.15626 15.0018 4.99999Z",
    fill: "#565A6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCrossSmall);
export default __webpack_public_path__ + "static/media/fi-rr-cross-small.cc0b74e374efb80d01b5f7b894070257.svg";
export { ForwardRef as ReactComponent };